module.exports = __webpack_public_path__ + "static/harrai-c71e5cd740180852ad73d3f8c00908fd.jpg";